<template>
  <div>
    <h3 class="mb-4">
      Transactions
    </h3>
    <v-sheet
      v-if="loading"
      :color="`grey lighten-4`"
      class="pa-3"
    >
      <v-skeleton-loader
        class="mx-auto d-flex flex-column align-content-space-between"
        min-height="600"
        type="paragraph, paragraph, paragraph, paragraph, paragraph, paragraph, actions"
      />
    </v-sheet>
    <v-card
      v-else
      class="pa-2"
      color="#f2f2f2"
    >
      <v-row>
        <template v-for="summary in summaryData">
          <v-col
            v-if="summary && summary.summary"
            :key="summary.tenant"
            cols="12"
            md="6"
          >
            <CardTransactionsSummaryDetail
              :name="summary.tenant"
              :data="summary.summary"
            />
          </v-col>
        </template>
      </v-row>
      <v-divider
        v-if="summary && summary.summary"
        :key="summary.tenant + 'divider'"
        class="mt-4 mb-4"
      />
    </v-card>
  </div>
</template>

<script>
import CardTransactionsSummaryDetail from "./CardTransactionsSummaryDetail";

export default {
  name: "CardTransactionsSummary",
  components: {
    CardTransactionsSummaryDetail
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    summaryData: {
      type: Array,
      default: () => []
    },
    license: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isDownloading: false,
      isStoreLoading: false
    };
  }
};
</script>
